import { type ReactNode } from 'react'
import { Card } from './Card'
import { Button } from '@app/components/core/button/Button'
import { Text } from '@app/components/core/typography/Text'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'

const imageStyle = {
  height: '14rem' as const,
  display: 'flex' as const,
  alignItems: 'center' as const,
  justifyContent: 'flex-start' as const,
  padding: '1rem' as const,
}

const contentStyle = { textAlign: 'left' as const, gap: '1rem'}
const titleStyle = { fontWeight: 700 as const, fontSize: '1.75rem' }

export interface DashboardInfoCardProps {
  image: string | ReactNode
  title: string
  description: string
  buttonLabel: string
  onClick?: () => void
}

export const DashboardInfoCard = ({
  image,
  title,
  description,
  buttonLabel,
  onClick,
}: DashboardInfoCardProps) => {
  return (
    <div style={{ height: '100%', width: '100%', display: 'flex' }}>
      <Card
        image={image}
        title={title}
        orientation="vertical"
        actionsAlign="start"
        imageStyle={imageStyle}
        imageObjectFit="contain"
        imageObjectPosition="left center"
        contentStyle={contentStyle}
        titleStyle={titleStyle}
        style={{ padding: '0.5rem', height: '100%', width: '100%' }}
      >
      <Text.Medium style={{ margin: 0, textAlign: 'left' }}>
        {description}
      </Text.Medium>
      <Card.Actions>
        <Button
          variant="secondary"
          label={buttonLabel}
          icon={faArrowRight}
          iconPosition="right"
          onClick={onClick}
        />
      </Card.Actions>
      </Card>
    </div>
  )
}
